<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"   @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
      <div class="line-box">
      <el-form-item label="公司" class="styW" prop="companyId" >
              
        <el-select v-model="dataForm.companyId" class="hundred" :disabled="isDisabled" filterable clearable placeholder="请选择公司">
                  <el-option
                          v-for="item in companys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
          <el-form-item label="城市" class="styW" prop="city">
<!--          <el-input v-model="dataForm.city" placeholder="城市"></el-input>-->
              <el-select v-model="dataForm.city" class="hundred" :disabled="isDisabled" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
      <el-form-item label="预算金额" class="styW"  prop="topLimitMoney">
          <el-input v-model="dataForm.topLimitMoney" placeholder="今日预算金额" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
      </el-form-item>

      <el-form-item label="产品类型" class="styW"  prop="productType">
        <el-select v-model="dataForm.productType"  filterable clearable placeholder="请选择产品类型">
            <el-option
                    v-for="item in loanTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
          <!-- <el-input v-model="dataForm.productType" placeholder="产品类型" oninput="value=value.replace(/[^0-9]/g,'')"></el-input> -->
      </el-form-item>
      <el-form-item label="今日分配人数" class="styW"  prop="numberOfPeopleAssignedToday">
        <el-input type="number" v-model.number="dataForm.numberOfPeopleAssignedToday" placeholder="请输入" min="1" oninput="value=value.replace(/[^\d]|^[0]/g,'')" ></el-input>
      </el-form-item>

      <!-- <el-form-item label="预算日期" prop="scheduledDate">
              <el-date-picker 
                      class="hundred"
                      v-model="dataForm.scheduledDate"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
      </el-form-item> -->
<!--          <el-form-item label="状态（开1、关0）" prop="status">-->
<!--          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>-->
<!--      </el-form-item>-->
      </div>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      citys: [],
      companys: [],
      loanTypes: [],
      visible: false,
      dataForm: {
        id: '',
        productType: '',
        companyId: '',
        numberOfPeopleAssignedToday: '',
        city: '',
        topLimitMoney: '',
        scheduledDate: '',
        status: '',
        createBy: '',
        createTime: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    isDisabled () {
      return this.dataForm.id ? true : false
    },
    dataRule () {
      return {
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        topLimitMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // scheduledDate: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
        this.getCityOptions();
        this.getCompanysOptions();
        this.getLoanTypeOptions()
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.getInfo()
          }
        })
    },
     // 获取当前时间
     getNowTime(){
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      let time = `${year}-${this.addZero(month)}-${this.addZero(day)} ${this.addZero(hour)}:${this.addZero(minute)}:${this.addZero(second)}`
      return time
    },
    addZero(s){
      return s < 10 ? `0${s}` : s
    },
      //初始化下拉框中的选项
      async getCityOptions() {
              this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
                console.log(res)
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.citys=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.citys.push({label:element.dictLabel,value:element.dictValue})
                      })
                      /*let citys = {}
                      for(let i = 0; i< res.data.length; i++){
                          citys[i].value=res.data[i].dictValue
                          citys[i].label=res.data[i].dictLabel
                      }*/
                  }
              }).catch(() => {})
      },
        //初始化贷款标识下拉框中的选项
     async getLoanTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=loan_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.loanTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.loanTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
        this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
          
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.companys=[];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.companys.push({label:element.name,value:element.id})
                })
            }
        }).catch(() => {})
    },
   
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/budget/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          productType: res.data.productType + ''

        }
       
        
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.id ? '' : this.dataForm.scheduledDate = this.getNowTime() 
        // if(this.dataForm.id && (this.getNowTime().split(' ')[0] != this.dataForm.scheduledDate.split(' ')[0])){
        //   this.$message.warning('只允许修改当天数据')
        //   return
        // }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/budget/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style>
/*添加css样式*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
 
input[type="number"] {
    -moz-appearance: textfield;
}


</style>
